import { render } from "./ExamInfoOphthalmicDiseases.vue?vue&type=template&id=837ed594&scoped=true"
import script from "./ExamInfoOphthalmicDiseases.vue?vue&type=script&lang=js"
export * from "./ExamInfoOphthalmicDiseases.vue?vue&type=script&lang=js"

import "./ExamInfoOphthalmicDiseases.vue?vue&type=style&index=0&id=837ed594&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837ed594"]])

export default __exports__